"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByOrder = void 0;
// eslint-disable-next-line @typescript-eslint/no-var-requires
const dotty = require('dotty');
/**
 * Returns whether or not a should come before b by recursively iterating over the properties.
 * @param {SubsectionWithAccessor} a The first section to sort
 * @param {SubsectionWithAccessor} b The second section to sort
 * @param {Object} schema The schema's properties
 * @param {string} [language="en"] The language string (usually "en")
 * @returns < 0 if a comes first. > 0 if b comes first.
 */
function sortByOrder(a, b, schema) {
    if (!a.propertyAccessor && !b.propertyAccessor) {
        return 0;
    }
    else if (!a.propertyAccessor) {
        return -1;
    }
    else if (!b.propertyAccessor) {
        return 1;
    }
    if (a.propertyAccessor.length === b.propertyAccessor.length) {
        const aProperty = dotty.get(schema, a.propertyAccessor);
        const bProperty = dotty.get(schema, b.propertyAccessor);
        return ((aProperty === null || aProperty === void 0 ? void 0 : aProperty.order) || 0) - ((bProperty === null || bProperty === void 0 ? void 0 : bProperty.order) || 0);
    }
    // Deep copy objects
    const newA = JSON.parse(JSON.stringify(a));
    const newB = JSON.parse(JSON.stringify(b));
    // Cut them down and recurse
    if (a.propertyAccessor.length > b.propertyAccessor.length) {
        newA.propertyAccessor.pop();
    }
    else {
        newB.propertyAccessor.pop();
    }
    return sortByOrder(newA, newB, schema);
}
exports.sortByOrder = sortByOrder;
//# sourceMappingURL=sortByOrder.js.map